import React from 'react';

function SectionLabel({ className = '', children }) {
  const classes = ['section-label', className].filter(Boolean).join(' ');

  return <div className={classes}>{children}</div>;
}

export default SectionLabel;
